import { useCallback, useEffect, useRef, useState } from 'react';

const FINAL_VALUE = 0;

export const useCountdown = (from: number, interval = 1000) => {
  const [count, setCount] = useState(FINAL_VALUE);

  const countdownRef = useRef<ReturnType<typeof setInterval>>();

  const startCountdown = useCallback(() => {
    setCount(from);

    countdownRef.current = setInterval(() => {
      setCount((prevState) => prevState - 1);
    }, interval);
  }, [from, interval]);

  const stopCountdown = useCallback(() => {
    clearInterval(countdownRef.current);
  }, [countdownRef]);

  useEffect(() => {
    if (countdownRef.current && count === FINAL_VALUE) {
      stopCountdown();
    }
  }, [countdownRef, count, stopCountdown]);

  useEffect(() => {
    return () => {
      if (countdownRef.current) {
        stopCountdown();
      }
    };
  }, [countdownRef, stopCountdown]);

  return {
    count,
    startCountdown,
    stopCountdown,
  };
};
